module.exports = __webpack_public_path__ + "static/carlene-70ac1600ca0120029203f842d90c8e3c.jpg";